
import React, { useEffect, useState, useRef, useMemo } from 'react';
import { StyleSheet, View, Image, findNodeHandle, Alert, TouchableOpacity, Keyboard, TouchableWithoutFeedback, ScrollView } from 'react-native';
import { TextInput, Text, Snackbar, ActivityIndicator, Button } from 'react-native-paper';
import Fondo from '../modules/component/Fondo';
import { MaterialIcons, Ionicons, FontAwesome5, Entypo } from '@expo/vector-icons';
import { useNavigation } from '@react-navigation/native';
import { Table, Row, Rows } from 'react-native-table-component';
import theme from './../../lib/theme.js';
import CustomModal from './CustomModal';
import Incidencias from './Incidencias';
import Lotes from './Lotes';
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view'
import { apiFetch } from '../modules/api';

const Upclote = () => {

  const navigation = useNavigation();
  const recargar = () => {
    navigation.replace(
      'UPCLote',
      null,
      null,
    );
  }




  /*async function validarGpsEncendido(){

    let { status } = await Location.requestForegroundPermissionsAsync();
    
        if (status !== 'granted') {
            setErrorMsg('Permission to access location was denied');
            gMsg = "Para poder utilizar esta aplicación es necesario dar permiso de ubicación a esta aplicación"
            showAlert();
            navigation.navigate("Acceso");
            return;
        }else{
          let location = await Location.watchPositionAsync(
            {accuracy:Location.Accuracy.High,
            timeInterval:5000,
            distanceInterval:10
          },
            (loc) => {
              gGeo = loc.coords;
            }
            );
        }
  }*/

  const showAlert = (titulo) => {
    alert(global.gMsg);
  }


  const [state, setState] = useState({
    exhibido: "",
    bodega: "",
    lote: gLote,
  });

  const [invETotal, setInvETotal] = useState(global.gInve)
  const [invBTotal, setInvBTotal] = useState(global.gInvb)
  const [invTotal, setInvTotal] = useState(global.gInve + global.gInvb)
  const [isLoadingInventory, setIsLoadingInventory] = useState(false);
  const [snackBarVisible, setSnackBarVisble] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [modalTablaVisible, setModalTablaVisible] = useState(false);
  const [modalLoteVisible, setModalLoteVisible] = useState(false);
  const [marginBotonView, setrMarginBottomView] = useState(0);
  const bottomSheetRef = useRef(null);
  const snapPoints = useMemo(() => ["10%", "30%", "50%"], []);
  const [hideDrawer, setHideDrawer] = useState(false);
  const scroll = useRef(null);

  useEffect(() => {
    const tmpState = { ...state };
    tmpState.lote = gLote;
    setState(tmpState);
  }, [modalLoteVisible])

  const [inv, setInv] = useState({

    exhibido: "",
    bodega: ""

  });

  const [foto, setFoto] = useState(null);

  useEffect(() => {
    const showSubscription = Keyboard.addListener('keyboardDidShow', () => {
      setHideDrawer(true);
    });
    const hideSubscription = Keyboard.addListener('keyboardDidHide', () => {
      setHideDrawer(false);
    });

    return () => {
      showSubscription.remove();
      hideSubscription.remove();
    };
  }, []);

  const handleChangetest = (name, value) => {
    setState({ ...state, [name]: value })
  }


  function limpiarFormulario() {

    setState("", "", global.gComentarios);

  }


  function onChanged(propiedad, text) {

    handleChangetest(propiedad, text.replace(/[^0-9]/g, ''))

  }


  function onChangedLote(text) {

    gLote = text

  }

  function SumarInv(accion, exhibido, bodega, comentarios) {

    Alert.alert('Sumar Inventario', 'Se agrego correctamente el inventario', [
      {
        text: "Aceptar",

      }
    ],
      { cancelable: true });
  }


  function operacion(tipo, accion, exhibido, bodega, comentarios) {
    let total_registros = global.gLotescapturados.DataTable1.length;
    let fecha = "";
    let lote = "";
    let exhibidoT = 0;
    let bodegaT = 0;
    let exhibidoT2 = 0;
    let bodegaT2 = 0;
    let lotecapturado = false;

    if (global.gLote == "Sin lote" && global.gLote == "Lote no encontrado") {

      lote = global.gLote;

    } else {

      fecha = global.gLote.substring(global.gLote.length - 10, global.gLote.length);
      lote = global.gLote.substring(0, global.gLote.length - 13);

    }

    if (!isNaN(parseInt(state.exhibido))) {

      exhibidoT = parseInt(state.exhibido);

    }

    if (!isNaN(parseInt(state.bodega))) {

      bodegaT = parseInt(state.bodega);

    }

    for (var i = 0; i < total_registros; i++) {

      if (global.gLotescapturados.DataTable1[i][0] == lote && global.gLotescapturados.DataTable1[i][1] == fecha) {

        lotecapturado = true;
        exhibidoT2 = parseInt(global.gLotescapturados.DataTable1[i][2]);
        bodegaT2 = parseInt(global.gLotescapturados.DataTable1[i][3]);

        if (isNaN(exhibidoT2) || exhibidoT2 == "NaN") {

          exhibidoT2 = 0;

        }

        if (isNaN(bodegaT2) || bodegaT2 == "NaN") {

          bodegaT2 = 0;

        }
      }
    }

    if (tipo == "s") {

      guardarInv(accion, lote, fecha, exhibido, bodega, comentarios, exhibidoT, exhibidoT2, bodegaT, bodegaT2);

    } else {

      restarInv(accion, lote, fecha, exhibido, bodega, comentarios, exhibidoT, exhibidoT2, bodegaT, bodegaT2, lotecapturado);

    }
  }

  function restarInv(accion, lote, fecha, exhibido, bodega, comentarios, exhibidoT, exhibidoT2, bodegaT, bodegaT2, lotecapturado) {

    if (!lotecapturado) {
      global.gMsg = "No puedes restar inventario a un lote que no le has ingresado datos";
      showAlert("Restar Inventario");
      return;
    }


    if ((exhibidoT > exhibidoT2) || (bodegaT > bodegaT2)) {
      global.gMsg = "No puedes restar una cantidad mayor a la capturada";
      showAlert("Restar Inventario");
      return;
    }


    Alert.alert('Restar Inventario', '¿Desea restar inventario?', [
      {
        text: "Aceptar",
        onPress: () => guardarInv(accion, lote, fecha, exhibido, bodega, comentarios, exhibidoT, exhibidoT2, bodegaT, bodegaT2)
      }
    ],
      { cancelable: true });
    lotecapturado = true;
  }

  const base64Icon = gApiPathFotoUpc + gUpc + '.jpg';

  async function guardarInv(accion, lote, fecha, exhibido, bodega, comentarios, exhibidoT, exhibidoT2, bodegaT, bodegaT2) {

    /* try{
     var altitude = gGeo.altitude
     var latitude = gGeo.latitude
     var longitude = gGeo.longitude
     var titulo = "";
     }catch{
 
       validarGpsEncendido();
 
 
     }*/

    var altitude = ""
    var latitude = ""
    var longitude = ""
    var titulo = "";
    var valoresenBlanco = 0;

    if (global.gLote == "") {

      global.gMsg = "Falta elegir el lote";
      showAlert("Faltan datos");
      return;

    }

    if (global.gInve == "NaN" || global.gInve === undefined) {

      global.gInve = "";

    }

    if (global.gInvb == "NaN" || global.gInvb === undefined) {

      global.gInvb = "";

    }

    if (exhibido == "NaN" || exhibido === undefined) {

      exhibido = "";

    }

    if (bodega == "NaN" || bodega === undefined) {

      bodega = "";

    }

    if (exhibido == "" && bodega == "") {


      valoresenBlanco = 1;

    }

    if (exhibido != "") {

      if (global.gInve != "") {

        if (accion == 0) {

          exhibido = String(parseFloat(gInve) + parseFloat(exhibido));
          global.gMsg = "El inventario se agregó correctamente";
          titulo = "Sumar inventario";

        } else {

          if (parseFloat(gInve) < parseFloat(exhibido)) {

            global.gMsg = "No puedes restar una cantidad mayor a lo registrado en exhibido";
            showAlert("Restar Inventario");
            return;

          }

          exhibido = String(parseFloat(gInve) - parseFloat(exhibido));
          global.gMsg = "El inventario se restó correctamente";
          titulo = "Restar inventario";

        }

      }

    } else {

      if (accion == 1) {

        if (parseFloat(gInve) < parseFloat(exhibido)) {
          global.gMsg = "No puedes restar una cantidad mayor a lo registrado en exhibido";
          showAlert("Restar Inventario");
          return;
        }

      }

      exhibido = global.gInve;

    }


    if (bodega != "") {

      if (global.gInvb != "") {

        if (accion == 0) {

          bodega = String(parseFloat(gInvb) + parseFloat(bodega));
          global.gMsg = "El inventario se agregó correctamente";
          titulo = "Sumar inventario";

        } else {

          if (parseFloat(gInvb) < parseFloat(bodega)) {

            global.gMsg = "No puedes restar una cantidad mayor a lo registrado en bodega";
            showAlert("Restar Inventario");
            return;

          }

          bodega = String(parseFloat(gInvb) - parseFloat(bodega));
          global.gMsg = "El inventario se restó correctamente";
          titulo = "Restar inventario";

        }

      }

    } else {


      if (accion == 1) {

        if (parseFloat(gInvb) < parseFloat(bodega)) {

          global.gMsg = "No puedes restar una cantidad mayor a lo registrado en bodega";
          showAlert("Restar Inventario");
          return;

        }

      }

      bodega = global.gInvb;

    }


    if ((exhibido != "" || bodega != "") && valoresenBlanco == 0) {

      let ex = 0;
      let bod = 0;
      if (accion == 0) {

        ex = parseInt(exhibidoT) + parseInt(exhibidoT2);
        bod = parseInt(bodegaT) + parseInt(bodegaT2);

      } else {

        ex = parseInt(exhibidoT2) - parseInt(exhibidoT);
        bod = parseInt(bodegaT2) - parseInt(bodegaT);

      }



      var datos = '{"operador" : "' + gOperador + '","determinante" : "' + gDeterminante + '", "upc" : "' + global.gUpc + '","inv_exhibido" : "' + ex + '","inv_bodega" :"' + bod + '","comentarios" :"' + gComentarios + '","lote" :"' + gLote + '","altitude":"' + altitude + '","latitude":"' + latitude + '","longitude":"' + longitude + '","inv_teorico":"' + gInvt + '"}'

      var requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: datos
      };
      setIsLoadingInventory(true);
      const response = await apiFetch(gApiPath + "/api/guardarInvLotes", requestOptions);
      const json = await response.json();

      if (json.estatus == "bien") {
        if (accion == 0) {
          agregarTabla(lote, fecha, exhibidoT, exhibidoT2, bodegaT, bodegaT2);
        } else {
          restarTabla(lote, fecha, exhibidoT, exhibidoT2, bodegaT, bodegaT2);
        }

        let total_registros = lotescapturados.DataTable1.length;
        let totalEx = 0;
        let totalBod = 0;

        for (var i = 0; i < total_registros; i++) {

          if (!isNaN(parseInt(lotescapturados.DataTable1[i][2]))) {
            totalEx = totalEx + parseInt(lotescapturados.DataTable1[i][2]);
          }
          if (!isNaN(parseInt(lotescapturados.DataTable1[i][3]))) {
            totalBod = totalBod + parseInt(lotescapturados.DataTable1[i][3]);
          }
        }

        global.gInve = totalEx;
        global.gInvb = totalBod;
        global.gLotescapturados.Footer = ['', 'Total:', totalEx, totalBod, totalEx + totalBod]

        setLotescapturados(global.gLotescapturados);

        setState("", "", comentarios);
        global.gLote = "";

        Alert.alert("Registro de inventario", "El inventario se actualizo de manera correcta", [
          { text: "Aceptar" }
        ],
          { cancelable: true });

        recargar();

      }

    }

  }


  function irLotes() {
    gPantalla = "";
    gCheckbox = "";
    setModalLoteVisible(true);
  }

  function irIncidencias() {
    gPantalla = "";
    gCheckbox = "";
    setModalVisible(true);
  }

  function irFotoProducto() {
    gFoto = "";
    gVerFoto = "";
    gMostrarFoto = "no";
    gImagen64 = "";
    gFoto1 = "";
    navigation.navigate("FotoProducto");


  }
  const [lotescapturados, setLotescapturados] = useState(
    {

      HeadTable1: ['Inventarios capturados'],
      HeadTable2: ['Lote', 'Caducidad', 'Exhibido', 'Bodega', 'Total'],
      DataTable1: [],
      Footer: []

    }
  );

  function agregarTabla(lote, fecha, exhibidoT, exhibidoT2, bodegaT, bodegaT2) {

    let total_registros = global.gLotescapturados.DataTable1.length;
    let agregar = true;
    let exhibidoSumar = 0;
    let bodegaSumar = 0;

    for (var i = 0; i < total_registros; i++) {

      if (global.gLotescapturados.DataTable1[i][0] == lote && global.gLotescapturados.DataTable1[i][1] == fecha) {


        exhibidoSumar = exhibidoT2 + exhibidoT;
        bodegaSumar = bodegaT2 + bodegaT;

        global.gLotescapturados.DataTable1[i] = [lote, fecha, exhibidoSumar, bodegaSumar, exhibidoSumar + bodegaSumar]
        agregar = false;

      }
    }

    if (agregar) {

      global.gLotescapturados.DataTable1[total_registros - 2] = [lote, fecha, state.exhibido, state.bodega, exhibidoT + bodegaT];

    }
    setLotescapturados(global.gLotescapturados);


  }


  function restarTabla(lote, fecha, exhibidoT, exhibidoT2, bodegaT, bodegaT2) {

    let total_registros = global.gLotescapturados.DataTable1.length;
    let exhibidoSumar = 0;
    let bodegaSumar = 0;

    for (var i = 0; i < total_registros; i++) {

      if (global.gLotescapturados.DataTable1[i][0] == lote && global.gLotescapturados.DataTable1[i][1] == fecha) {

        exhibidoSumar = exhibidoT2 - exhibidoT;
        bodegaSumar = bodegaT2 - bodegaT;

        global.gLotescapturados.DataTable1[i] = [lote, fecha, exhibidoSumar, bodegaSumar, exhibidoSumar + bodegaSumar]


      }
    }
    setLotescapturados(global.gLotescapturados);

  }

  useEffect(function () {

    let mounted = true;
    global.gPantalla = "";

    setInv(
      {

        exhibido: global.gInve,
        bodega: global.gInvb

      });


    const unsubscribe = navigation.addListener('focus', () => {
      setState(
        {

          exhibido: "",
          bodega: "",
          lote: global.gLote

        });
    });

    async function fetchData() {

      if (mounted) {

        var datos = '{"operador" : "' + gOperador + '","determinante" : "' + gDeterminante + '", "upc" : "' + global.gUpc + '"}'

        var requestOptions = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: datos
        };

        const response = await apiFetch(gApiPath + "/api/listarInvPorLote", requestOptions)

        const json = await response.json();

        global.gLotescapturados =
        {

          HeadTable1: ['Inventarios capturados'],
          HeadTable2: ['Lote', 'Caducidad', 'Exhibido', 'Bodega', 'Total'],
          DataTable1: [],
          Footer: []

        }

        let x = 0;
        let lote = "";
        let fecha = "";
        let exhibidoT = 0;
        let bodegaT = 0

        json.datos.forEach(i => {

          if (i.lote == "Sin lote" && i.lote == "Lote no encontrado") {

            lote = i.lote;

          } else {

            let valor = i.lote || '';

            fecha = valor.substring(valor.length - 10, valor.length);
            lote = valor.substring(0, valor.length - 13);


          }

          if (!isNaN(parseInt(i.inv_exhibido))) {

            exhibidoT = parseInt(i.inv_exhibido);

          }

          if (!isNaN(parseInt(i.inv_bodega))) {

            bodegaT = parseInt(i.inv_bodega);

          }


          global.gLotescapturados.DataTable1[x] = [lote, fecha, exhibidoT, bodegaT, exhibidoT + bodegaT];

          x = x + 1;


        });

        let total_registros = global.gLotescapturados.DataTable1.length;
        let totalEx = 0;
        let totalBod = 0;

        for (var i = 0; i < total_registros; i++) {

          if (!isNaN(parseInt(global.gLotescapturados.DataTable1[i][2]))) {
            totalEx = totalEx + parseInt(global.gLotescapturados.DataTable1[i][2]);
          }
          if (!isNaN(parseInt(global.gLotescapturados.DataTable1[i][3]))) {
            totalBod = totalBod + parseInt(global.gLotescapturados.DataTable1[i][3]);
          }
        }

        setInv(totalEx, totalBod);
        global.gInve = totalEx;
        global.gInvb = totalBod;
        global.gLotescapturados.Footer = ['', 'Total:', totalEx, totalBod, totalEx + totalBod]

        setLotescapturados(global.gLotescapturados);
      }
    }

    fetchData();
    return () => mounted = false;

  }, []);

  const validaDatos = (exhibido, bodega) => {
    if ((!exhibido && !bodega)) {
      return true;
    }
    if (((exhibido.trim() === "") &&
      (bodega.trim() === ""))) {
      return true;
    }
    return false;
  }
  const scrollToInput = (reactNode) => {
    //scroll.current.scrollToFocusedInput(reactNode)
    scroll.current.scrollToPosition(0, reactNode)
  }

  const TableContent = (props) => {
    return (
      <View style={{ width: "100%", minHeight: 100, paddingHorizontal: "3%", marginVertical: "5%" }}>
        <ScrollView style={{ marginBottom: "10%", maxHeight: 500 }}>
          <Table borderStyle={{ paddingTop: 40, borderWidth: 1, borderColor: '#CCC', backgroundColor: "#FFF" }} style={{ borderRadius: 10, borderColor: "#CCC", borderStyle: "solid", borderWidth: 1, minWidth: '100%', marginBottom: 20 }} >
            <Row data={lotescapturados.HeadTable1} style={styles.text} textStyle={styles.text} />
            <Row data={lotescapturados.HeadTable2} style={styles.TableText} textStyle={styles.TableText} />
            <Rows data={global.gLotescapturados.DataTable1} style={styles.TableText} textStyle={styles.TableText} />
            <Row data={lotescapturados.Footer} style={styles.TableText} textStyle={styles.TableText} />
          </Table>
        </ScrollView>
        <TouchableWithoutFeedback>
          <Button onPress={() => setModalTablaVisible(false)} mode="contained" style={{ ...theme.buttons.error }}>
            Cerrar
          </Button>
        </TouchableWithoutFeedback>
      </View>
    )
  };


  return (
    <View style={styles.container}>
      <Fondo />
      <CustomModal modalVisible={modalLoteVisible} setModalVisible={setModalLoteVisible} Content={Lotes} setSnackBarVisble={setSnackBarVisble} />
      <CustomModal modalVisible={modalVisible} setModalVisible={setModalVisible} Content={Incidencias} setSnackBarVisble={setSnackBarVisble} />
      <CustomModal modalVisible={modalTablaVisible} setModalVisible={setModalTablaVisible} Content={TableContent} setSnackBarVisble={setSnackBarVisble} />
      <Snackbar
        visible={snackBarVisible}
        style={{ zIndex: 2 }}
        duration={3000}
        onDismiss={() => setSnackBarVisble(false)}
        action={{
          label: 'Cerrar',
          onPress: () => {
            setSnackBarVisble(false)
          },
        }}>
        Las incidencias se guardaron correctamente
      </Snackbar>
      <View style={{  height: "120px" , maxHeight: 130, width: "100%" }} >
        <View
          style={{
            ...theme.cards, backgroundColor: "#fff",
            flexWrap: 'wrap', flex: 1, height: 110, maxHeight: 130, justifyContent: "center"
          }}>
          <View style={{ alignItems: 'center', justifyContent: "center", height: "100%", marginRight: 10 }}>
            <MaterialIcons style={{ textAlign: 'center' }} name="local-grocery-store" size={50} color="#333" />
          </View>
          <View style={{ whiteSpace: "nowrap", maxWidth: 300 }}>
            <Text style={{ ...theme.subTitle, fontWeight: 'bold' }} ellipsizeMode="tail" numberOfLines={2}>UPC: {gUpc}</Text>
            <Text style={theme.subTitle2} ellipsizeMode="tail" numberOfLines={3}>{gDescripcionUpc}</Text>
          </View>
        </View>
      </View>
      <KeyboardAwareScrollView keyboardShouldPersistTaps='handled'
        ref={scroll} style={{width: "100%"}}
      >
        <View style={{ alignItems: 'center', justifyContent: 'center' }}>
          <View style={{ alignItems: 'center', flexDirection: 'column', flex: 1 }}>
            <Image style={{ width: 126, height: 126 }} source={{ uri: base64Icon }} />
          </View>
          <View style={{ alignItems: 'center', flexDirection: 'row', flex: 1, marginVertical: "3%" }}>
            <Text style={{ ...theme.subTitle2, marginRight: '5%' }}>Teórico: <Text style={{ ...theme.subTitle2, fontWeight: 'bold' }}> {gInvt}</Text></Text>
            <Text style={{ ...theme.subTitle2, marginRight: '5%' }}>Inv. real: <Text style={{ ...theme.subTitle2, fontWeight: 'bold' }}> {(Number(gInve) + Number(gInvb))}</Text></Text>
            <Text style={{ ...theme.subTitle2, color: ((Number(gInve) + Number(gInvb)) - gInvt) !== 0 ? theme.colors.danger : theme.colors.success }}>Diferencia: <Text style={{ ...theme.subTitle2, fontWeight: 'bold', color: ((Number(gInve) + Number(gInvb)) - gInvt) !== 0 ? theme.colors.danger : theme.colors.success }}>{(Number(gInve) + Number(gInvb)) - gInvt}</Text></Text>
          </View>

          <View style={{ alignItems: 'center', width: "100%", marginBottom: "2%" }}>
            <TouchableOpacity onPress={() => irLotes()} style={{ width: "95%", paddingHorizontal: "3%" }} >
              <TextInput
                label={"Lote"}
                value={state.lote}
                mode='outlined'
                style={{ width: "100%", color: "black" }}
              />
            </TouchableOpacity>
          </View>
          <View style={{ width: '100%', paddingHorizontal: "3%", flexDirection: 'row', flex: 1, marginBottom: "10px" }}>
            <View style={{ width: '50%' }}>
              <TouchableOpacity onPress={() => irIncidencias()} style={{ ...theme.buttonCardsSmall, ...theme.buttonContentCardsSmall, backgroundColor: theme.colors.primaryLight }}>
                <FontAwesome5 name="tasks" style={{ textAlign: 'center' }} size={30} color="#333" />
                <Text style={theme.buttonContentTextSmall}>Incidencias</Text>
              </TouchableOpacity>
            </View>
            <View style={{ width: '50%' }}>
              {!isLoadingInventory ? (
                <View style={{ width: '100%', alignItems: 'center', flexDirection: 'row', flex: 1, marginLeft: "5%" }}>
                  <TouchableOpacity style={{ marginRight: "5%" }} disabled={validaDatos(state.exhibido, state.bodega)} onPress={() => operacion("s", 0, state.exhibido, state.bodega, state.comentarios)}>
                    <Ionicons name="add-circle-sharp" size={70} color={validaDatos(state.exhibido, state.bodega) ? theme.colors.gray : theme.colors.success} />
                  </TouchableOpacity>
                  <TouchableOpacity disabled={validaDatos(state.exhibido, state.bodega)} onPress={() => operacion("r", 1, state.exhibido, state.bodega, state.comentarios)}>
                    <Ionicons name="remove-circle-sharp" size={70} color={validaDatos(state.exhibido, state.bodega) ? theme.colors.gray : theme.colors.danger} />
                  </TouchableOpacity>
                </View>
              ) : (
                <View style={{ width: '100%', alignItems: 'center', marginTop: '20%' }}>
                  <ActivityIndicator animating={true} color={theme.colors.primary} size={"large"} />
                </View>
              )}
            </View>
          </View>
          <View style={{ width: '100%', paddingHorizontal: "3%", flexDirection: 'row', flex: 1 }}>
            <View style={{ width: '50%' }}>
              <TouchableOpacity onPress={() => irFotoProducto()} style={{ ...theme.buttonCardsSmall, ...theme.buttonContentCardsSmall, backgroundColor: theme.colors.primaryLight }}>
                <Entypo name="camera" style={{ textAlign: 'center' }} size={30} color="#333" />
                <Text style={theme.buttonContentTextSmall}>Imágen</Text>
              </TouchableOpacity>
            </View>
            <View style={{ width: '47%' }}>
              <TextInput
                label={"Exhibido: " + gInve}
                value={state.exhibido}
                onChangeText={(value) => onChanged("exhibido", value)}
                keyboardType="numeric"
                mode='outlined'
                onPressIn={(event) => {
                  scrollToInput(findNodeHandle(event.target))
                }}
              />
              <TextInput
                label={"Bodega: " + gInvb}
                value={state.bodega}
                onChangeText={(value) => onChanged("bodega", value)}
                keyboardType="numeric"
                mode='outlined'
                onPressIn={(event) => {
                  scrollToInput(findNodeHandle(event.target))
                }}
              />
            </View>
          </View>
          <Button onPress={() => setModalTablaVisible(true)} mode="contained" style={{ marginTop: 20, marginBottom: 10, width: "90%" }}>
            {'Ver lotes registrados'}
          </Button>
        </View>
      </KeyboardAwareScrollView>
      {/*hideDrawer && (
        <BottomSheet
          ref={bottomSheetRef}
          snapPoints={snapPoints}
          style={{ ...styles.drawer }}
        >
          <BottomSheetView style={styles.contentContainer}>
            <TableContent />
          </BottomSheetView>
        </BottomSheet>
      )*/}

    </View>
  );
}

export default Upclote


const styles = StyleSheet.create({
  container: {
    backgroundColor: '#f1f1f1',
    alignItems: 'center',
    height: "100%"
  },
  scrollView: {
    width: '100%',
    height: '100%',
    marginHorizontal: "3%",
  },
  TableText: {
    fontSize: 12,
    textAlign: 'center',
    color: "black",
    fontWeight: 'bold',
    backgroundColor: "#fff",
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 50,
  },
  TableText2: {
    fontSize: 14,
    textAlign: 'center',
    color: "black",
    fontWeight: 'bold',
    backgroundColor: "#fff",
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 50,
  },
  text: {
    fontSize: 20,
    color: 'white',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: "#23abdc",
    textAlign: 'center',
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10
  },
  contentContainer: {
    flex: 1,
    alignItems: 'center',
  },
  drawer: {
    borderTopLeftRadius: 15,
    borderTopRightRadius: 15,
    shadowOffset: {
      width: 0,
      height: -10,
    },
    shadowOpacity: 1,
    shadowRadius: 3.84,
    elevation: 10,
    borderRadius: 15,
    zIndex: 99,
    backgroundColor: 'white',
    shadowColor: '#000'
  }
});

